export function alignmentClassName(
  widgetAlignment: string | null
): string | undefined {
  if (widgetAlignment === "center") return "justify-content-center"
  if (widgetAlignment === "right") return "justify-content-end"
  return "justify-content-start"
}
